import { getErrorDetail } from 'components/utility/utils';
import { fetchOrchidAPI } from 'utils/api';

export default async function removeRoleFromTeam (
  teamId: number,
  roleId: number,
): Promise<void> {
  const response = await fetchOrchidAPI(
    `/api/users/v1/team/${teamId}/roles/${roleId}`,
    { method: 'DELETE' },
  );
  if (!response.ok) {
    throw new Error(getErrorDetail(await response.text()));
  }
}
